import {formatDateTime, formatTime, createValidDate} from '../../../../utils/DateUtil';
import {ICellRendererParams} from '@ag-grid-community/core';

export const DateCellRenderer = (data: ICellRendererParams): string => {
    const date = createValidDate(data.value);
    if (!date) {
        return '-';
    }
    return formatDateTime(date, false);
};

export const TimeCellRenderer = (data: ICellRendererParams): string => {
    const date = createValidDate(data.value);
    if (!date) {
        return '-';
    }
    return formatTime(date, false);
};
